export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  REVIEWS: '/reviews',
  NOT_FOUND: '*',
} as const

export const API_ENDPOINTS = {
  MARKET: {
    TICKERS: '/market/tickers',
    ORDERBOOK: (symbol: string) => `/market/${encodeURIComponent(symbol)}/orderbook`,
    TRADES: (symbol: string) => `/market/${encodeURIComponent(symbol)}/trades`,
    KLINES: (symbol: string) => `/market/${encodeURIComponent(symbol)}/klines`,
  },
  STATS: '/stats',
} as const

export const QUERY_KEYS = {
  MARKET: {
    TICKERS: ['market', 'tickers'],
    ORDERBOOK: (symbol: string) => ['market', 'orderbook', symbol],
    TRADES: (symbol: string) => ['market', 'trades', symbol],
  },
  WINNERS: {
    ALL: ['winners'],
  },
  STATS: ['stats'],
} as const
